import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const CardAppointmentEncounterUX = (props: any) => {
    return(
      <div>
        <Table
          headers={props.languageUX === "en" ? "Date,Time,Doctor" : "วันที่,เวลา,ชื่อแพทย์"}
          id="CardAppointmentEncounterUX-Table-1"
          minRows={8}
          showPagination={false}
          style={{height: "300px"}}>
        </Table>
        <div
          id="CardAppointmentEncounterUX-div-2"
          style={{display: "flex", justifyContent: "flex-end", padding: "10px"}}>
          
          <Button
            color="green"
            id="CardAppointmentEncounterUX-Button-3">
            {props.languageUX === "en" ? "Open Encounter" : "เปิด Encounter"}
          </Button>
        </div>
      </div>
    )
}


export default CardAppointmentEncounterUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Sep 11 2025 08:09:07 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 1,
      "name": "Table",
      "parent": 0,
      "props": {
        "headers": {
          "type": "value",
          "value": "วันที่,เวลา,ชื่อแพทย์",
          "valueEN": "Date,Time,Doctor"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentEncounterUX-Table-1"
        },
        "minRows": {
          "type": "code",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentEncounterUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", padding: \"10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "เปิด Encounter",
          "valueEN": "Open Encounter"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentEncounterUX-Button-3"
        }
      },
      "seq": 3,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardAppointmentEncounterUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
